import {Component, OnInit} from '@angular/core';
import Chart from 'chart.js/auto';
import {ApiService} from '../services/api.service';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-service-health-status',
    imports: [],
    templateUrl: './service-health-status.component.html',
    styleUrl: './service-health-status.component.css'
})
export class ServiceHealthStatusComponent implements OnInit {
  healthService: any;

  constructor( private apiService: ApiService, private toastr: ToastrService){
   
   
  }
  ngOnInit() {
    this.getHealthStatus()
    // this.initUptimeGraphs();
   
  }

  getHealthStatus(){
    this.apiService.healthStatus().subscribe({
      next: (data: any) => {
        this.healthService = data
        this.initUptimeGraphs();
      },
      error: (err) => {
        this.toastr.error('Something wrong while getting health status!')
      }
    })
  }

  private initUptimeGraphs() {
    const cards = document.querySelectorAll('.service-card');

    cards.forEach(card => {
      const canvas = card.querySelector('.uptime-graph canvas');
      const serviceNameElement = card.querySelector('.service-name');
      const serviceStatus = serviceNameElement && serviceNameElement.textContent ? 
        this.healthService?.services[serviceNameElement.textContent.trim().toLowerCase().replace(' ', '_')]?.status?.toLowerCase() : null;

      // Generate sample data for the last 24 hours
      const labels = Array.from({length: 24}, (_, i) => `${23-i}h`).reverse();
      const data = this.generateUptimeData(24, serviceStatus === 'operational');

      
      new Chart(canvas as HTMLCanvasElement, {
        type: 'line',
        data: {
          labels: labels,
          datasets: [{
            label: 'Uptime',
            data: data,
            borderColor: serviceStatus === 'operational' ? '#16a34a' : '#dc2626',
            backgroundColor: serviceStatus === 'operational' ? 'rgba(22, 163, 74, 0.1)' : 'rgba(220, 38, 38, 0.1)',
            tension: 0.4,
            fill: true,
            pointRadius: 0,
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              mode: 'index',
              intersect: false,
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              max: 100,
              ticks: {
                callback: value => `${value}%`
              }
            },
            x: {
              grid: {
                display: false
              }
            }
          }
        }
      });
    });
  }

  private generateUptimeData(points: number, isOperational: boolean): number[] {
    return Array.from({length: points}, () => {
      if (isOperational) {
        return 95 + Math.random() * 5; // 95-100% for operational services
      } else {
        return Math.random() * 30; // 0-30% for down services
      }
    });
  }
}
